import { render, staticRenderFns } from "./ChangeStatusOfReservation.vue?vue&type=template&id=6150753e&scoped=true"
import script from "./ChangeStatusOfReservation.vue?vue&type=script&lang=js"
export * from "./ChangeStatusOfReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6150753e",
  null
  
)

export default component.exports